module.exports = __webpack_public_path__ + "img/icon-analytics.3b91ee1a.svg";